import React from 'react';

import { flagStyles } from '../settings';

const SvgIL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2424px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIL;
